export default "__VITE_ASSET__f9751e8d__"